import { sdkLogger } from '../../logger/logger';
import type { SdkLoggableError } from '../../types/shared';
import type { SubmitRequestBody } from '../types';

export function logSubmitStart(url: string, requestBody: SubmitRequestBody): void {
  sdkLogger.info('Starting survey response HTTP POST...', { url, requestBody });
}

export function logSubmitWarn(msg: string, err: SdkLoggableError): void {
  sdkLogger.warn(msg, { err });
}

export function logSubmitPerfSuccess(
  durationMs: number,
  status: number,
  url: string,
  requestSize: string,
  responseSize: string
): void {
  sdkLogger.perf({
    apiName: 'POST Submit Response',
    durationMs,
    status,
    url,
    requestSize,
    responseSize,
    success: true,
  });
}

export function logSubmitPerfFailure(
  durationMs: number,
  status: number | string,
  url: string,
  requestSize: string
): void {
  sdkLogger.perf({
    apiName: 'POST Submit Response',
    durationMs,
    status,
    url,
    requestSize,
    success: false,
  });
}

export function logSubmitSuccess(responseId: string): void {
  sdkLogger.success('Survey response submitted successfully', { responseId });
}

export function logSubmitError(msg: string, err: SdkLoggableError): void {
  sdkLogger.error(msg, { err });
}
